export const FREE_LEGAL_SERVICE_ID: number = 1;
